import code from "../../api/code";

export const dream = {// lzx
  key: "97e0087a918d5a2b1c0d68f37b274f24",
  code: "463b1d95c0cb9fb698da9f19808d02d4",
};
export const sheng = {// myy
  key: "24d2a66b395de2e95640d7dda1423023",
  code: "8334fea6381773ea8eaf944d23302ae8",
};
export const chaos = {
    key:'9523eb717433e6e99698c0933964ca64',
    code:'3fb6df037c83fe86ba5e4ef91fa4f35b',
};
